import Cookie from 'js-cookie'

export function getLocale () {
  let lang = Cookie.get('language')
  if (lang === undefined) {
    lang = navigator.language
  }

  return lang.substring(0, 2) === 'nl' ? 'nl' : 'en'
}

export function setLocale (locale) {
  Cookie.set('language', locale)
}
